import {takeLatest, takeEvery, put} from 'redux-saga/effects';
import {CREATE_TYPE, UPDATE_TYPE, DELETE_TYPE} from './constants';
import {createTypeSuccess, deleteTypeSuccess, updateTypeSuccess} from './actions';
import {requestTypeCreation, requestTypeUpdate, requestTypeDelete} from './api';
import { putActionActionBuffer } from "../../actionBuffer/actions";

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{quiz, type}>>}
 */
function* createType(actionObj) {
    const quiz = yield requestTypeCreation({quizLocalizationId: actionObj.quizLocalizationId});
    if (quiz) {
        yield put(createTypeSuccess(quiz));
    }
}

/**
 *
 * @param typeId
 * @param title
 * @param selectedType
 * @param button
 * @param url_image
 * @param description
 * @param images
 * @returns {IterableIterator<PutEffect<{quiz, type}>>}
 */
function* updateType({typeId, title, selectedType,  button, url_image, description, image_copyright, images}) {
    const quiz = yield requestTypeUpdate({typeId, title, selectedType,  button, url_image, description, image_copyright, images: {...images}});
    yield put (putActionActionBuffer( {
        saveAction: true,
        actionBuff: [
            {
                'updateType': {
                    content: {
                        typeId, title, selectedType,  button, url_image, description, images: {...images}
                    }
                }
            }
        ]
    }));
    if (quiz) {
        yield put(updateTypeSuccess(quiz));
    }
}

/**
 *
 * @param typeId
 * @returns {IterableIterator<PutEffect<{quiz, type}>>}
 */
function* deleteType({typeId}) {
    const quiz = yield requestTypeDelete({typeId});
    if (quiz) {
        yield put(deleteTypeSuccess(quiz));
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchTypes() {
    yield takeEvery(CREATE_TYPE, createType);
    yield takeLatest(UPDATE_TYPE, updateType);
    yield takeLatest(DELETE_TYPE, deleteType);
}

export default watchTypes;

